/* !
 * productsDetail.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const a = 'is-active';
	const thisParent = FUNCTIONS.va.pathname.split('/')[2];
	const thisCategory = FUNCTIONS.va.pathname.split('/')[3];
	const thisID = FUNCTIONS.va.pathname.split('/')[4].replace(/\.html/, '');

	// [共通] スライダーの矢印位置調整
	const updateArrowPosition = (_slide, _arrows) => {
		if (_slide) {
			const imageHeight = _slide.offsetHeight;
			_arrows.forEach(arrow => {
				arrow.style.top = `${imageHeight / 2}px`;
			});
		}
	};

	// オンラインショップ モーダルボタン消し込み
	const removeShopBtn = () => {
		if (document.getElementsByClassName('prod-detail-shopBtn').length && !document.querySelectorAll('.mod-onlineshopLink li').length) {
			document.querySelector('.mod-modalContent[data-target="modal_onlineshop"]').remove();
			document.querySelector('.prod-detail-shopBtn').remove();
		}
	};
	removeShopBtn();

	// メイン画像切り替え
	const changeMainImg = () => {
		const images = document.querySelectorAll('.js-selectMainImg');
		images[0].classList.add(a);

		images.forEach(ele => {
			ele.addEventListener('click', e => {
				document.querySelector('.__mainImg img').src = ele.querySelector('img').src;
				images.forEach(ele2 => {
					if (ele2.classList.contains(a)) { ele2.classList.remove(a); }
				});
				ele.classList.add(a);
			});
		});
	};
	changeMainImg();

	// 動画モーダル
	const modalVideo = () => {
		if (document.querySelectorAll('.js-modal-video').length) {
			const videoModal = new ModalVideo('.js-modal-video', {
				channel: 'youtube',
				autoplay: 1,
			});
			document.querySelectorAll('.js-modal-video').forEach(ele => {
				ele.addEventListener('click', (event) => {
					event.preventDefault();
					videoModal.open();
				});
			});
		}
	};
	modalVideo();

	// アレルゲン空欄処理
	const emptyRemoveAllergenList = () => {
		document.querySelectorAll('.__allergenList li').forEach(ele => {
			if (!ele.querySelector('span')) { ele.remove(); }
		});
		document.querySelectorAll('.__allergenList').forEach(ele => {
			if (!ele.querySelector('li')) {
				ele.textContent = '無し';
			}
		});
	};
	emptyRemoveAllergenList();

	// 同じカテゴリの商品出力
	const setOtherProdList = () => {
		fetch(`/ajax/products/list/${thisParent}/${thisCategory}.json?exclude_id=${thisID}`).then(response => response.json()).then(data => {
			if (data.rt_bn_product_list.length) {
				let prodList = data.rt_bn_product_list;
				let prodListHTML = '';
				prodList.forEach(prod => {
					prodListHTML += `<li class="__item splide__slide"><a href="${prod.rt_cf_p_detail_href.href}" class="mod-boxLink01"><figure>` +
						`<div><img src="${prod.rt_cf_p_img.src}" alt="" loading="lazy" width="256" height="256"></div>` +
						`<figcaption class="mod-link01"><span>${prod.rt_cf_p_product_title.content}</span></figcaption></figure></a></li>`;
				});
				document.querySelector('.prod-detail-otherProd .splide__list').innerHTML = prodListHTML;

				const pagination =
					((FUNCTIONS.va.window.width >= FUNCTIONS.va.device.desktop && prodList.length > 5) ||
					 (FUNCTIONS.va.window.width < FUNCTIONS.va.device.desktop && FUNCTIONS.va.window.width >= FUNCTIONS.va.device.sp && prodList.length > 3) ||
					 (FUNCTIONS.va.window.width < FUNCTIONS.va.device.desktop && prodList.length > 2)) ? true : false ;

				// スライダー起動
				const otherProdSlider = document.querySelector('.prod-detail-otherProd-slider.splide');
				const splide_otherProd = new Splide('.prod-detail-otherProd-slider.splide', {
					type: 'slide',
					perPage: 5,
					perMove: 5,
					autoplay: false,
					speed: 500,
					arrows: true,
					pagination: pagination,
					paginationKeyboard: true,
					flickPower: 200,
					waitForTransition: false,
					gap: '20px',
					breakpoints: {
						768: {
							perPage: 3,
							perMove: 3,
						},
						640: {
							perPage: 2,
							perMove: 2,
							gap: '15px'
						},
					}
				});
				splide_otherProd.mount();
				updateArrowPosition(otherProdSlider.querySelectorAll('.splide__slide img')[0], otherProdSlider.querySelectorAll('.splide__arrow'));

				window.addEventListener('resize', () => {
					updateArrowPosition(otherProdSlider.querySelectorAll('.splide__slide img')[0], otherProdSlider.querySelectorAll('.splide__arrow'));
				});
			} else {
				document.querySelector('#otherProducts').remove();
				document.querySelectorAll('.mod-anchor li')[0].remove();

				if (!document.querySelectorAll('.mod-anchor li').length) {
					document.querySelector('.mod-anchor').remove();
				}
			}
		});
	};
	setOtherProdList();

	// この商品を使ったレシピ 最大5件 SPのみスライダー
	const setRecipeList = () => {
		if (document.querySelector('#recipes')) {
			const recipeSlider = document.querySelector('.prod-detail-recipe-slider.splide');
			let recipeList = recipeSlider.querySelectorAll('.splide__slide');
			const pagination =
				((FUNCTIONS.va.window.width < FUNCTIONS.va.device.desktop && FUNCTIONS.va.window.width >= FUNCTIONS.va.device.sp && recipeList.length > 3) ||
				 (FUNCTIONS.va.window.width < FUNCTIONS.va.device.desktop && recipeList.length > 2)) ? true : false;

			const splide_recipe = new Splide('.prod-detail-recipe-slider.splide', {
				type: 'slide',
				perPage: 5,
				perMove: 5,
				autoplay: false,
				speed: 500,
				arrows: false,
				pagination: false,
				paginationKeyboard: true,
				flickPower: 200,
				waitForTransition: false,
				gap: '20px',
				breakpoints: {
					768: {
						perPage: 3,
						perMove: 3,
						arrows: true,
						pagination: pagination,
					},
					640: {
						perPage: 2,
						perMove: 2,
						gap: '15px'
					},
				}
			});
			splide_recipe.mount();
			updateArrowPosition(recipeSlider.querySelectorAll('.splide__slide img')[0], recipeSlider.querySelectorAll('.splide__arrow'));

			window.addEventListener('resize', () => {
				updateArrowPosition(recipeSlider.querySelectorAll('.splide__slide img')[0], recipeSlider.querySelectorAll('.splide__arrow'));
			});
		}
	};
	setRecipeList();

	// 大カテゴリ回遊プルダウン カレント削除
	const removeSelectCatCurrent = () => {
		document.querySelectorAll('.prod-detail-bottomNav .__selectCategory li').forEach(ele => {
			if (ele.querySelector('a').getAttribute('data-id') === thisParent) {
				ele.remove();
			}
		});
	};
	removeSelectCatCurrent();

})(window.FUNCTIONS);